<template>
    <div ref="visualization" id="visualization"></div>
</template>
<script>
export default {
    name: 'NetworkGraph',
};
</script>
<script setup>
import { onMounted, ref, watch } from 'vue';
import { Network } from 'vis-network/standalone';

const props = defineProps({
    nodes: {
        required: true,
        type: Array,
    },
    edges: {
        required: true,
        type: Array,
    },
    options: {
        required: true,
        type: Object,
    },
});

const visualization = ref(null);

function draw() {
    const network = new Network(visualization.value, { nodes: props.nodes, edges: props.edges }, props.options);
}

watch([() => props.edges, () => props.options], () => {
    draw();
});

onMounted(() => {
    draw();
});
</script>
<style scoped>
#visualization {
    width: 100%;
    height: 600px;
    border: 1px solid lightgray;
}
</style>
